/*
创建者 魏强(2018.1.30)
农特生鲜 banner
*/
<template>
  <div class="right-sidebar" :style="{height:'auto'}">
      <div class="ad_item" v-for="item in list" :key="item.key">
        <router-link :to="item.to" target="_blank">
          <img :src="item.atturl" width="258" height="180"   :alt="item.aname">
        </router-link>
      </div>
  </div>
</template>
<script>
import {pcTopAdv} from 'api/home';
import {parseAdvList} from 'utils/tool';
export default {
    data () {
          return {
              list:[]
          }
      },
      created(){
        this.fetchData();
      },
      methods:{
        fetchData(){
          pcTopAdv(41).then(json=>{
            if(json.resCode==1){
              let data = json.data;
              this.list =parseAdvList(data.advInfoList[0].advList);
            }
          })
        }
      }
}
</script>



// WEBPACK FOOTER //
// banner-right-flow.vue?74e03e0e